export const AUTHORIZATION = 'Authorization';
export const BEARER = 'Bearer ';
export const EDITION = '2026'; // 版本
export const SYSTEM_NAME = '意见征集管理后台'; ///系统名称
export const COMPANY = 'pg技术支持'; // 公司名
export const PHONE = '1311111111'; // 联系方式
export const RECORD_NUMBER = '11111'; //备案号

// export const URL = 'http://192.168.0.71:8881/upm-app'; //公司网址
export const URL = 'https://admin.zhugejiaoxue.cn/upm-app'; //公司网址
export const PICTURE_URL = ''; 

export const PAGE_SIZE = 10;

export const QUERY = 'QUERY';

export const SYS_BASE_URL = '/upm-app';

export const SAVE = 'save';
export const UPDATE = 'update';
export const DELETE = 'delete';
export const UNBIND = 'unbind';
export const BIND = 'bind';
export const UNBIND_API = 'unbindApi';
export const BIND_API = 'bindApi';

export const SYS_DEF = ["00","02"];